import { Controller } from "@hotwired/stimulus"
import { ResizableTableColumns } from "@validide/resizable-table-columns"

class ColumnSizeStore {
  get(key) {
    return JSON.parse(localStorage.getItem(key))
  }

  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  }
}

export default class extends Controller {
  initialize() {
    new ResizableTableColumns(this.element, {
      minWidth: 16,
      store: new ColumnSizeStore(),
    })
  }

  connect() {
    const tableWrapper = this.element.parentElement

    tableWrapper.dataset.horizontalScrollPosition = "start"

    tableWrapper.addEventListener("scroll", () => {
      if (tableWrapper.scrollLeft === 0) {
        tableWrapper.dataset.horizontalScrollPosition = "start"
      } else if (tableWrapper.scrollLeft + tableWrapper.offsetWidth >= tableWrapper.scrollWidth) {
        tableWrapper.dataset.horizontalScrollPosition = "end"
      } else {
        tableWrapper.dataset.horizontalScrollPosition = "scrolling"
      }
    })
  }

  showAngleDownIcon(event) {
    const angleDownIcon = this._findAngleDownIcon(event.target)
    if (angleDownIcon) {
      angleDownIcon.classList.add("is-visible")
    }
  }

  hideAngleDownIcon(event) {
    const angleDownIcon = this._findAngleDownIcon(event.target)

    if (angleDownIcon) {
      angleDownIcon.classList.remove("is-visible")
    }
  }

  _findAngleDownIcon(cell) {
    const columnIndex = cell.cellIndex
    const headerRow = this.element.querySelector("thead tr") || this.element.rows[0]
    const headerCell = headerRow.cells[columnIndex]
    return headerCell.querySelector(".h-data-table-cell__dropdown-trigger")
  }
}
